/* eslint-disable prefer-template */
import * as React from 'react';
import { UploadContext } from '@insync-students-stores/uploadContext';
import { IFileWithStatus } from '@insync-students-constants/files/files.enum';
export const UploadProvider: React.FC = ({
  children
}) => {
  const base = 'insync-student-lib-uploadedFiles';
  const cleanStorageForId = (id: string) => {
    const amountOfFiles = Number(window.localStorage.getItem(base + ':' + id + ':' + 0));
    for (let i = 1; i <= amountOfFiles; i++) {
      localStorage.removeItem(base + ':' + id + ':' + i);
    }
    localStorage.removeItem(base + ':' + id + ':' + 0);
  };
  const storeUploadedFiles = (id: string, updatedUploadedFiles: IFileWithStatus[]) => {
    cleanStorageForId(id);
    const storeFile = (file, index) => {
      const storableFile = {
        file: {
          name: file.file.name,
          lastModified: file.file.lastModified,
          id: file.file.id,
          uploadedDate: file.file.uploadedDate
        },
        status: file.status
      };
      window.localStorage.setItem(base + ':' + id + ':' + (index + 1), JSON.stringify(storableFile));
      window.localStorage.setItem(base + ':' + id + ':' + 0, index + 1);
    };
    if (window.localStorage) {
      updatedUploadedFiles.forEach(storeFile);
    }
  };
  const retrieveUploadedFiles = (id: string): IFileWithStatus[] => {
    const retrievedFiles = [];
    if (window.localStorage) {
      const amountOfFiles = Number(window.localStorage.getItem(base + ':' + id + ':' + 0));
      for (let i = 1; i <= amountOfFiles; i++) {
        retrievedFiles.push(JSON.parse(window.localStorage.getItem(base + ':' + id + ':' + i)));
      }
    }
    return retrievedFiles;
  };
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <UploadContext.Provider value={{
      retrieveUploadedFiles,
      storeUploadedFiles
    }}>
      {children}
    </UploadContext.Provider>
  );
};